const CustomRegistrationOption = ({ children, darkMode, ...props }) => {
    const isSelected = props.isSelected;
    const isFocused = props.isFocused;
    const isDisabled = props.isDisabled;

    return (
        <div
            {...props.innerProps}
            style={{
                ...props.getStyles('option', props),
                padding: '8px 12px',
                fontSize: '16px',
                borderBottom: '1px solid ' + (darkMode ? '#444' : '#eee'),
                backgroundColor: isSelected
                    ? 'var(--chakra-colors-brand-500)'
                    : isFocused
                      ? darkMode
                          ? 'rgba(255, 255, 255, 0.16)'
                          : '#f5f5f5'
                      : 'transparent',
                color: isSelected
                    ? 'white'
                    : isDisabled
                      ? 'rgb(204,204,204)'
                      : 'inherit',
            }}
            title={
                isDisabled
                    ? 'This registration is already in use by another number.'
                    : `Select registration ${props.data.extension}`
            }>
            {children}
        </div>
    );
};

export { CustomRegistrationOption };
